export enum LOCAL_STORAGE_KEYS {
  ADMIN_AUTH_TOKEN_EXPIRES_AT = 'admin_auth_token_expires_at',
  ADMIN_AUTH_TOKEN_JWT = 'admin_auth_token',
  ADMIN_DIAGNOSTICS_DATA_GRID_STATE = 'admin_diagnostics_data_grid_state',
  ADMIN_DIAGNOSTICS_SELECTED_ERRORS = 'admin_diagnostics_selected_errors',
  AUTH_TOKEN_EXPIRES_AT = 'auth_token_expires_at',
  AUTH_TOKEN_JWT = 'auth_token',
  STAGING_BANNER_DISMISSED_REF = 'staging_banner_dismissed_ref',
}

export class LocalStorage {
  getItem(key: LOCAL_STORAGE_KEYS) {
    return localStorage.getItem(key);
  }

  setItem(key: LOCAL_STORAGE_KEYS, value: string) {
    localStorage.setItem(key, value);
  }

  removeItem(key: LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

export const LocalStorageInstance = new LocalStorage();
